import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LAZY_VIEW_ENTRY_COMPONENT } from '../lazy-view/lazy-view-entry-component.injection-token';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { RecommendedModule } from '../recommended/recommended.module';
import { ActivityDescriptionModule } from '../shared/activity/activity-description.module';
import { AnalyticsDescriptionModule } from '../shared/analytics/analytics-description.module';
import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { FocusOnLoadModule } from '../shared/focus-on-load/focus-on-load.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { MruItemModule } from '../shared/mru-item/mru-item.module';
import { ResizeModule } from '../shared/resize/resize.module';
import { TitleAnnouncerModule } from '../shared/title-announcer/title-announcer.module';
import { MruComponent } from './mru.component';

@NgModule({
    imports: [
        CommonModule,
        FocusOnLoadModule,
        IconFontModule,
        InstrumentationModule,
        LazyViewModule,
        ResizeModule,
        SharedComponentsModule,
        TitleAnnouncerModule,
        ActivityDescriptionModule,
        AnalyticsDescriptionModule,
        MruItemModule,
        RecommendedModule
    ],
    declarations: [
        MruComponent
    ],
    exports: [
        MruComponent
    ],
    providers: [
        { provide: LAZY_VIEW_ENTRY_COMPONENT, useValue: MruComponent }
    ],
    entryComponents: [
        MruComponent
    ]
})
export class MruModule {
}
